module.exports = __webpack_public_path__ + "static/media/comic_plate_2.52f5d807.png";